import React from 'react';
import { useNearby } from '@hooks/useNearby';

const lineEq = (y2: number, y1: number, x2: number, x1: number, currentVal: number) => {
  // y = mx + b
  const m = (y2 - y1) / (x2 - x1);
  const b = y1 - m * x1;
  return m * currentVal + b;
};

interface ProximityParams {
  distanceMin: number;
  distanceMax: number;
  feedbackValueFrom: number;
  feedbackValueTo: number;
}

export const useProximityFeedback = (
  elementRef: React.RefObject<HTMLElement>,
  proximityParams: ProximityParams,
  onProximityChange: (isInProximityArea: boolean, feedbackValue: number) => void
) => {
  useNearby(elementRef, (distance) => {
    const animationValue = lineEq(
      proximityParams.feedbackValueFrom,
      proximityParams.feedbackValueTo,
      proximityParams.distanceMax,
      proximityParams.distanceMin,
      distance
    );
    const isInProximityArea = distance <= proximityParams.distanceMax && distance >= proximityParams.distanceMin;
    onProximityChange(isInProximityArea, animationValue);
  });
};
